import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { RootStore, BookingCCStore } from 'AppClient/stores';

import { CCSelect } from 'components';

import styles from './styles.module.scss';

interface Props {
	bookingCCStore?: BookingCCStore;
}

@inject(({ bookingCCStore }: RootStore) => ({
	bookingCCStore,
}))
@observer
export default class CreditCardsSection extends Component<Props> {
	getAlertMessage = () => {
		const { isInitialCardDeleted, isInitialCardExpired } = this.props.bookingCCStore!;

		if (isInitialCardDeleted) {
			return 'Initially selected credit card is deleted';
		}

		if (isInitialCardExpired) {
			return 'Initially selected credit card is expired';
		}

		return undefined;
	};

	render() {
		const {
			oneTimeCreditCards,
			availableCreditCards,
			addOneTimeCreditCard,
			setBookingCardId,
			isCreditCardUser,
			fetchStatus,
			currentBookingCardId,
		} = this.props.bookingCCStore!;

		const expiredOrDeletedMessage = this.getAlertMessage();

		if (!availableCreditCards || !isCreditCardUser) return null;

		return (
			<div className={styles.bookingCard}>
				<CCSelect
					containerName="bookingCC"
					creditCards={availableCreditCards}
					oneTimeCreditCards={oneTimeCreditCards}
					setBookingCardId={setBookingCardId}
					addOneTimeCard={addOneTimeCreditCard}
					fetchStatus={fetchStatus}
					value={currentBookingCardId}
					warningMessage={expiredOrDeletedMessage}
				/>
			</div>
		);
	}
}
